/**
 * File: sticky-header.js
 *
 * Helpers for the primary navigation.
 */

( function () {
	const nav = document.querySelector( '.home .site-header' );
	const navTop = 70;

	if ( nav ) {
		document.addEventListener( 'scroll', updateNavPosition );
	}

	/**
	 * Adds the down arrow to parent menu items.
	 *
	 * @author Corey Collins
	 * @since January 31, 2020
	 */
	function updateNavPosition() {
		if ( window.scrollY >= navTop ) {
			nav.classList.add( 'site-header-sticky' );
		} else {
			nav.classList.remove( 'site-header-sticky' );
		}
	}
} )();
